import script from "./SelectLanguages.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectLanguages.vue?vue&type=script&setup=true&lang=js"

import "./SelectLanguages.vue?vue&type=style&index=0&id=d2887716&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2887716"]])

export default __exports__